import { capitalize } from "lodash";
import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import ShareButton from "PFApp/components/activity_share/share_button";
import ViewInBookingModuleButton from "PFApp/components/view_in_booking_module_button";
import ButtonLink from "PFComponents/button/button_link";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useActivityNameAndId } from "PFCore/helpers/activities";
import React from "react";

import ActivityShowMenuButton from "../../details/activity_details_menu_button";
import { useTranslatedActivityType } from "../../hooks/use_translated_activity_type";
import { Actions } from "../../parts/actions";
import buttonClasses from "../activity_page_button.module.scss";
import { Breadcrumbs } from "./breadcrumbs";
import css from "./header.module.scss";

export const Header = () => {
  const {
    canSeeBookingModule,
    shortlistsMeta,
    suspendedShortlistsMeta,
    task: activity,
    tabActiveId,
    isAudit
  } = useActivityPageContext();

  const getActivityNameId = useActivityNameAndId();
  const templateName = useTranslatedActivityType();

  if (!activity) {
    return null;
  }

  const nameAndId = getActivityNameId(activity);

  const shortListCount = (shortlistsMeta?.total || 0) + (suspendedShortlistsMeta?.total || 0);

  return (
    <div className={css.header}>
      <div className={css.title}>
        <Breadcrumbs />
        <Typography variant="h1" noMargin>
          <span>{`${templateName}: ${capitalize(nameAndId.name)}`}</span>
        </Typography>
        {nameAndId.id && <Typography variant="bodyRegular" noMargin>{`ID: ${nameAndId.id}`}</Typography>}
      </div>
      <div className={css.actions}>
        <Actions task={activity} />
        {activity.coowned && (
          <ButtonLink theme={buttonClasses} href={`/activities/${activity.id}/edit`} kind="tertiary">
            <Icon name="edit" size="sm" />
          </ButtonLink>
        )}
        {canSeeBookingModule && (
          <ViewInBookingModuleButton
            openAllocateManually={tabActiveId === "shortlist" && shortListCount > 0}
            classes={buttonClasses}
          />
        )}
        {activity.state !== "draft" && activity.coowned && !isAudit && (
          <ShareButton
            activityType="role"
            kind="tertiary"
            activityIds={[activity.id]}
            withTitle={false}
            classes={buttonClasses}
          />
        )}
        <ActivityShowMenuButton />
      </div>
    </div>
  );
};
